module.exports = __webpack_public_path__ + "static/Bitpie-b76c959e7aaf5399cecfbe82ec6af92f.png";